import React from "react";
import { Box, Button, Grid, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import { updateRole } from "redux/actions";
import { RoleData } from "types/models/master/MasterApp";

interface RoleProps {
  Role?: RoleData;
}

const RoleUpdate: React.FC<RoleProps> = ({ Role }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    role: Yup.string().required("Role Name is required"),
    moduleType: Yup.number().required("Module Type is required"),
    status: Yup.boolean().required("Status is required"),
  });

  const handleSubmit = async (values: any) => {
    const dataPayload = {
      role: values.role,
      moduleType: values.moduleType,
      isActive: values.status ? 1 : 0,
    };

    try {
      if (Role) {
        console.log("Updating Role:", dataPayload);
        const response = await dispatch(updateRole(Role.id, dataPayload)) as unknown as AxiosResponse<any>;
        if (response.status === 200) {
          navigate(`/master/manageRole/roles`);
        }
      }
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  return (
    <Box sx={{ height: "100%", width: "100%", m: 8 }}>
      <Grid sx={{ display: "flex", flexDirection: "column", height: "100%", margin: 2 }}>
        <Formik
          enableReinitialize
          initialValues={{
            role: Role?.role || "",
            moduleType: Role?.moduleType || "",
            status: Role?.isActive === 1 ? true : false,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, touched, errors }) => (
            <Form>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Role Name"
                    name="role"
                    variant="outlined"
                    error={touched.role && !!errors.role}
                    helperText={<ErrorMessage name="role" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Module Type"
                    name="moduleType"
                    variant="outlined"
                    error={touched.moduleType && !!errors.moduleType}
                    helperText={<ErrorMessage name="moduleType" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Select Status"
                    name="status"
                    select
                    variant="outlined"
                    SelectProps={{ native: true }}
                    error={touched.status && !!errors.status}
                    helperText={<ErrorMessage name="status" />}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      setFieldValue("status", e.target.value === "true");
                    }}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </Field>
                </Grid>
              </Grid>

              

              <Box
  sx={{
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    py: 2,
    px: 4,
    zIndex: 1000,
    backgroundColor: "white",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)", 
  }}
>

                <Button variant="outlined" color="secondary" onClick={() => navigate("/master/manageRole/roles")}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  {Role ? "Update Role" : "Add Role"}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Grid>
    </Box>
  );
};

export default RoleUpdate;
